import { useAction, useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { useMemo } from 'use-memo-one'

import { Button, Eye1Icon, Eye2Icon, Tooltip } from '@blade/ui-kit'

import { reatomPositionVisibilityToggle } from '../../visibility/atoms'

import type {
  AggregatedPositionModel,
  WalletPositionModel,
} from '@root/entities/position'

export const PositionsTableVisibilityCell = ({
  position,
}: {
  position: WalletPositionModel | AggregatedPositionModel
}) => {
  const { t } = useTranslation()
  const [hidden] = useAtom(position.hidden)
  const model = useMemo(
    () =>
      // eslint-disable-next-line @reatom/unit-naming-rule
      reatomPositionVisibilityToggle({
        pairAddress: position.pairAddress,
        network: position.network,
      }),
    [position.network, position.pairAddress],
  )
  const toggleVisibility = useAction(model.execute)
  const [requestState] = useAtom(model)

  const tooltipContent = hidden
    ? t('position.unhide-position.tooltip')
    : t('position.hide-position.tooltip')

  return (
    <Tooltip content={tooltipContent}>
      <Root
        variant="soft"
        radius="rounded"
        size="xs"
        busy={requestState.loading}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          toggleVisibility()
        }}
        iconLeft={hidden ? <Eye1Icon /> : <Eye2Icon />}
      ></Root>
    </Tooltip>
  )
}

const Root = styled(Button)`
  height: 30px;
  width: 30px;
`
